import axios from 'axios';

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';
export const API_ORIGIN = API_URL.replace(/\/api\/?$/, '');

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem('teamlab_admin_token');

    if (adminToken) {
      config.headers.Authorization = `Bearer ${adminToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle errors globally
    if (error.response?.status === 401) {
      // Ne pas effacer la session admin sur un 401 du parcours joueur (même navigateur).
      const path = window.location.pathname;
      // Pages publiques : pas de redirection (sinon le message d'erreur disparaît au rechargement).
      if (path.startsWith('/admin') && path !== '/admin/login' && path !== '/admin/set-password') {
        localStorage.removeItem('teamlab_admin_token');
        window.location.href = '/admin/login';
      }
    }

    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default apiClient;
